import _ from 'underscore';
import { LocationTarget } from '@bingads-webui-react/bing-maps';

export const McaTargetModel = {
  LocationTarget: '#Model.LocationTarget',
  RadiusTarget: '#Model.RadiusTarget',
  AgeTarget: '#Model.AgeTarget',
  GenderTarget: '#Model.GenderTarget',
};

export const DEFAULT_RADIUS_SIZE = 25;
export const DEFAULT_RADIUS_UNIT = 'mi';
export const MIN_LOCATION_TARGETS = 1;
export const MAX_LOCATION_TARGETS = 100;
export const MI_RADIUS_UNIT = 'mi';
export const KM_RADIUS_UNIT = 'km';

export const McaRadiusUnit = {
  Miles: 'Miles',
  Kilometers: 'Kilometers',
};

export const formatSuggestedLocation = (location) => {
  const {
    LocationType,
    CountryCode,
    Latitude,
    Longitude,
    BingLocationId,
    Name,
    localizationKey,
  } = location;

  const locationData = {
    Type: LocationType,
    CountryCode,
    ExpandedName: !_.isEmpty(localizationKey) ? localizationKey : Name,
    GeoPoint: {
      Latitude,
      Longitude,
    },
    Id: BingLocationId,
  };

  return LocationTarget.CreateIncludedLocationTarget(locationData);
};

export const convertFromLocationTarget = (locationTarget) => {
  // see: private/MultiChannelAds/BusinessMT/Model/Ads/Target.cs
  const mcaTarget = {
    Name: locationTarget.ExpandedName,
    Latitude: locationTarget.Latitude,
    Longitude: locationTarget.Longitude,
    BingLocationId: locationTarget.LocationId,
    CountryCode: locationTarget.CountryCode,
  };

  // set Id if it is available
  if (locationTarget.Id) {
    mcaTarget.Id = locationTarget.Id;
  }

  // find City and State values in locationTarget.location.ParentLocations array
  _.each(_.get(locationTarget, ['location', 'ParentLocations']), (parent) => {
    if (!mcaTarget.City && parent.Type === 'City') {
      mcaTarget.City = parent.ExpandedName;
    } else if (!mcaTarget.State && parent.Type === 'SubGeography') {
      mcaTarget.State = parent.ExpandedName;
    }
  });

  if (locationTarget.isRadiusLocationTarget) {
    // see: private/MultiChannelAds/BusinessMT/Model/Ads/RadiusTarget.cs
    _.extend(mcaTarget, {
      '@odata.type': McaTargetModel.RadiusTarget,
      BingLocationId: 0,
      RadiusLength: locationTarget.radiusSize,
      RadiusUnit: locationTarget.radiusUnit === KM_RADIUS_UNIT ? McaRadiusUnit.Kilometers : McaRadiusUnit.Miles,
    });
  } else {
    // see: private/MultiChannelAds/BusinessMT/Model/Ads/LocationTarget.cs
    _.extend(mcaTarget, {
      '@odata.type': McaTargetModel.LocationTarget,
      LocationType: locationTarget.LocationType,
    });
  }

  return mcaTarget;
};
